<div #documentVersionHistoryModal class="documentVersionHistoryModal">
  <p-dialog
    header="Document Version History"
    [(visible)]="viewDocumentHistoryModal"
    [draggable]="false"
    [style]="{ width: '100vw', height: '95vh' }"
    (onHide)="closeDocumentVersionHistoryModal()"
    [modal]="true"
    id="documentVersionHistoryModal"
  >
    <app-panel-list *ngIf = "!showLoader" [panelList]="documentVersionsHistoryModalInput" [noResultFound] = "noData">
      <ng-template #templateRef let-data="dataVar">
        <div panel-content class="grid">
          <div class="col-fixed text-left" style="width: 8%">
            <app-label labelText="Version #"></app-label>
            <div class="grid">
              <div class="col max-w-3rem">
                <app-read-only readonlyText="{{ data?.version }}"></app-read-only>
              </div>
              <div class="col max-w-0 pl-0"
                ><em
                  class="pi pi-external-link blue-color cursor-pointer"
                  (click)="loadDocumentDetails(data?.version)"
                ></em
              ></div>
            </div>          
          </div>
          <div class="col-fixed text-left" style="width: 14%">
            <app-label labelText="Phase"></app-label> 
            <div class="grid">
              <div class="col max-w-0">
                <em
                  class="pi pi-circle-fill"
                  [ngClass]="calculatePhaseColor(data?.phaseName)"
                ></em>
              </div>
              <div class="col ml-1">
              <app-read-only readonlyText="{{ data?.phaseName }}"></app-read-only>
              </div>
            </div>
          </div>
          <div class="col-fixed text-left" style="width: 15%" *ngIf="displayEffectiveDateField(data?.phase)">
            <app-label labelText="Effective Date"></app-label>
            <app-read-only readonlyText="{{ data?.effectiveDate | date: 'dd-MMM-yyyy' }}"></app-read-only>
          </div>
          <div class="col-fixed text-left" style="width: 15%" *ngIf="displayReqEffectiveDateField(data?.phase)">
            <app-label labelText="Requested Effective Date"></app-label>
            <app-read-only readonlyText="
              {{ data?.requestedEffectiveDate | date: 'dd-MMM-yyyy' }}"></app-read-only>
          </div>
          <div class="col-fixed text-left" style="width: 52%">
            <app-label labelText="Approver(s)"></app-label>
            <app-read-only readonlyText="{{ data?.approvers }}"></app-read-only>
          </div>
          <div class="col-fixed text-left m-auto" style="width: 11%">
            <button
              *ngIf="showOrHideChangeRequestItemButton(data?.phaseName)"
              pButton
              type="button"
              label="Change Request Items"
              (click)="
                openChangeRequestItemModal(
                  data?.version,
                  data?.phase,
                  data?.phaseName
                )
              "
              class="button-text bpt-button-compact mt-1 font-semibold"
            ></button>
          </div>
        </div>
      </ng-template>
    </app-panel-list>

  </p-dialog>
</div>
<div >
  <app-change-request-history-modal
  *ngIf="isChangeRequestHistoryModalShow"
    [documentDetailsDto]="documentDetailsDto"
    [isChangeRequestHistoryModalShow]="isChangeRequestHistoryModalShow"
    [isLatestVersion]="isLatestVersion"
    [documentPhase]="documentPhase"
    (isCloseChangeRequestItemHistoryModal)="
      closeChangeRequestItemHistoryModal($event)
    "
    (isLatestDocument)="updateIsLatestVersion($event)"
  >
  </app-change-request-history-modal>
</div>
